<script>
import { mapState } from 'vuex';
import appConfig from "@/app.config";
import Loading from "@/components/Loading";
import {getSites, deleteSite} from "@/api/sites";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
    }),
  },
  methods: {
    get(page) {
      this.loading = true;
      getSites({page}).then((response) => {
        this.items = response.data.data.docs;
        this.pages = response.data.data.pages;
        this.total = response.data.data.total;
        this.limit = response.data.data.limit;
        this.loading = false;
      });
    },
    handleDelete(id) {
      Swal.fire({
        title: "Silmek istediğinizden emin misiniz?",
        text: "Bu işlemi geri alamazsınız!",
        icon: "error",
        showCancelButton: true,
        cancelButtonText: "Vazgeç",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sil"
      }).then((result) => {
        if(result.value){
          deleteSite(id).then(() => {
            this.get(this.page);
          })
        }
      })
    },
    handleOpenApiKeys(site) {
      this.modalData = {
        appKey: site.appKey,
        appSecret: site.appSecret
      }
      this.$bvModal.show('keys-modal');
    },
    createManualLink(site) {
      const base = `${String(site._id)}.${site.appKey}.${site.appSecret}`;
      return btoa(base).replace("==", "");
    },
    handleOpenManualKeys(site) {
      const link = this.createManualLink(site);
      this.modalData = {
        link: `https://${this.config.url}/deposit/${link}`
      }
      this.$bvModal.show('manual-modal');
    },
    copyContent(element) {
      const copyText = document.getElementById(element);
      copyText.select();
      document.execCommand("copy");
    }
  },
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      items: [],
      page: 1,
      pages: 0,
      total: 0,
      limit: 0,
      modalData: null,
      statusColors: ["bg-danger", "bg-success"],
      statusNames: ["Pasif", "Aktif"],
    };
  },
  mounted() {
    this.get(1);
  },
  beforeDestroy() {
  }
};
</script>

<template>
  <div class="position-relative">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h4 class="card-title mb-0">Siteler</h4>
              <b-button :to="'/sites/add'" variant="success" size="sm">Site Ekle</b-button>
            </div>
            <b-card-text class="table-responsive">
              <table class="table table-centered table-nowrap table-hover table-striped">
                <thead>
                <tr>
                  <th>Site Adı</th>
                  <th class="text-center">Durum</th>
                  <th class="text-right">Tarih</th>
                  <th class="text-right" style="width:10%;"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td><h5 class="font-size-14 mb-0">{{ item.name }}</h5></td>
                  <td class="text-center">
                    <span class="badge badge-pill" :class="statusColors[item.status]">{{statusNames[item.status]}}</span>
                  </td>
                  <td class="text-right">
                    <p class="font-size-13 mb-0">{{item.createdAt | formatDate}}</p>
                  </td>
                  <td class="text-right">
                    <b-button @click="handleOpenManualKeys(item)" class="mr-2" variant="dark" size="sm">Links</b-button>
                    <b-button @click="handleOpenApiKeys(item)" class="mr-2" variant="primary" size="sm">API Keys</b-button>
                    <b-button :to="'/sites/' + item._id" class="mr-2" variant="warning" size="sm">Düzenle</b-button>
                    <b-button @click="handleDelete(item._id)" variant="danger" size="sm">Sil</b-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-card-text>
            <b-pagination
                v-model="page"
                :total-rows="total"
                :per-page="limit"
                @change="get"
                aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" />
    <b-modal id="keys-modal" hide-footer title="Api Keys">
      <div role="tablist">
        <b-card v-if="modalData"  no-body class="mb-1">
          <b-card-body>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="appKey" class="col-form-label">Application Key</label>
                  <b-input-group>
                    <input id="appKey" readonly v-model="modalData.appKey" type="text" class="form-control" />
                    <template v-slot:append>
                      <b-button variant="success" @click="copyContent('appKey')">
                        <i class="bx bx-copy-alt"></i>
                      </b-button>
                    </template>
                  </b-input-group>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="appSecret" class="col-form-label">Application Secret</label>
                  <b-input-group>
                    <input id="appSecret" readonly v-model="modalData.appSecret" type="text" class="form-control" />
                    <template v-slot:append>
                      <b-button variant="success" @click="copyContent('appSecret')">
                        <i class="bx bx-copy-alt"></i>
                      </b-button>
                    </template>
                  </b-input-group>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>
    <b-modal id="manual-modal" hide-footer title="Manuel Entegrasyon Linkleri">
      <div role="tablist">
        <b-card v-if="modalData"  no-body class="mb-1">
          <b-card-body>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-2">
                  <label for="appKey" class="col-form-label">Yatırım Linki</label>
                  <b-input-group>
                    <input id="manualDepositLink" readonly v-model="modalData.link" type="text" class="form-control" />
                    <template v-slot:append>
                      <b-button variant="success" @click="copyContent('manualDepositLink')">
                        <i class="bx bx-copy-alt"></i>
                      </b-button>
                    </template>
                  </b-input-group>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>
